import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import MenuBuilder from './containers/Menu/Menu';
import Landing from './containers/Landing';
import { PrivacyTerms } from './containers/Landing/PrivacyTerms';
import { TermsAndConditions } from './containers/Landing/TermsAndConditions';
import { userIsAuthenticatedRedir, userIsNotAuthenticatedRedir } from './auth';
import asyncComponent from './hoc/asyncComponent/asyncComponent';
import './App.scss';

const MenuComponent = userIsAuthenticatedRedir(MenuBuilder);
const LandingComponent = userIsNotAuthenticatedRedir(Landing);
const asyncSignUp = asyncComponent(() => {
  return import('./containers/SignUp/SignUp');
});

const asyncChangePassword = asyncComponent(() => {
  return import('./containers/Password/ChangePassword');
});

const asyncResetPassword = asyncComponent(() => {
  return import('./containers/Password/ResetPassword');
});

const asyncUnsubscribe = asyncComponent(() => {
  return import('./containers/Unsubscribe');
});

const asyncLinkVoucher = asyncComponent(() => {
  return import('./containers/LinkVoucher');
});

class App extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route path="/Signup" component={asyncSignUp} />
          <Route path="/Unsubscribe" component={asyncUnsubscribe} />
          <Route path="/ChangePassword" component={asyncChangePassword} />
          <Route path="/ResetPassword" component={asyncResetPassword} />
          <Route path="/Menu" component={MenuComponent} />
          <Route path="/GetVoucher" component={asyncLinkVoucher} />
          <Route path="/" exact component={LandingComponent} />
          <Route path="/Privacy" component={PrivacyTerms} />
          <Route path="/Terms" component={TermsAndConditions} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js